import React from 'react';

import styles from './servicesList.module.scss';

import { ListOfServices } from '@modules/services/ListOfServices';

export const ServicesList = () => {
  return (
    <section>
      <div className={styles.root}>
        <ListOfServices
          styles={styles}
          customLabel={'Our Services'}
          customHeadings={
            <>
              {' '}
              We've completed over 20,000+ services across London, Edinburgh and
              Brighton, with 15+ multiple service lines, including:{' '}
            </>
          }
          serrviceList={[
            { name: 'Appliance repair' },
            { name: 'Appliance supply and installation' },
            { name: 'Appliance disposal' },
            { name: 'Electric oven repair' },
            { name: 'Gas oven repair' },
            { name: 'Gas hob repair' },
            { name: 'Washing machine repair' },
            { name: 'Tumble dryer repair' },
            { name: 'Dishwasher repair' },
            { name: 'Cooker hood repair' },
            { name: 'Extractor fan repairs' },
            { name: 'Leaking appliances' },
          ]}
          customFooter={
            <>
              Every service comes with our 12-month labour guarantee. No hidden
              costs. No unreliable contractors. Just straightforward property
              maintenance that puts you first.
            </>
          }
        />
      </div>
    </section>
  );
};
